import { Col, DatePicker, Form } from "antd";
import moment from "moment";
import CustomDatePicker from "common/CustomDatePicker";

const SwingvsFoldingFilterFields = ({ initialTableData }) => {
  // UX sweep default: last 7 days ending today. This FilterFields component is used only
  // by "sewing_and_folding" (SwingvsFoldingReport), so an unconditional default is safe.
  // Final fix wave (I2): computed inside the component body (not module scope) so a
  // long-open tab re-evaluates "today" on the next render instead of freezing it at the
  // moment the JS bundle first loaded.
  const DEFAULT_START_DATE = moment().subtract(6, "days").format("YYYY-MM-DD");
  const DEFAULT_END_DATE = moment().format("YYYY-MM-DD");
  return (
    <>
      <Col span={4}>
        <Form.Item
          label="Start Date"
          name="start_date"
          required
          initialValue={DEFAULT_START_DATE}
          rules={[
            {
              required: true,
              message: "Start Date is required",
            },
          ]}
        >
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item
          label="End Date"
          name="end_date"
          required
          initialValue={DEFAULT_END_DATE}
          rules={[
            {
              required: true,
              message: "End Date is required",
            },
          ]}
        >
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
    </>
  );
};

export default SwingvsFoldingFilterFields;
